/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kooperationspartner1Inputs */

const de__field_kooperationspartner1 = /** @type {(inputs: _Field_Kooperationspartner1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kooperationspartner`)
};

/**

* @param {_Field_Kooperationspartner1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kooperationspartner1 = /** @type {((inputs?: _Field_Kooperationspartner1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kooperationspartner1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kooperationspartner1(inputs)
});
export { _field_kooperationspartner1 as "_field_Kooperationspartner" }